import React, { useEffect, useRef, useState } from 'react';
import styles from './ccf-customer-channels.module.scss';
import {
  CcfDoubleArrowIcon,
  CcfPlusIcon,
  CcfPhoneOutboundIcon,
  CcfEmailIcon,
  CcfWhatsAppIcon,
  CcfMessageOutlineIcon,
  CcfMailOutlineIcon,
  CcfVideoOutlineIcon,
  CcfEditBookIcon,
  CcfPhoneOutlineIcon,
  CcfTypography,
  CcfAccordion,
  CcfAccordionSummary,
  CcfAccordionDetails,
  CcfTextField,
  CcfXIcon,
} from '@nice-ccf/ui-controls';
import { updateCustomerChnnelInformation } from '../../../ccf-inbox/ccf-inbox.slice';
import {
  MediaType,
  DigitalChannelType,
  ChannelActions,
} from '@nice-ccf/core-sdk';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import { activeContactSelector } from '../../ccf-inbox.slice';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslator, CcfBox } from '@nice-ccf/ui-controls';
import { IconButton, Direction, TextField, useTheme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { getApplicationDirection } from '@nice-ccf/ui-components';
import customerCardStyles from '../ccf-customer-card.styles';
const useStyles = makeStyles((theme) =>
  createStyles({
    inputRoot: {
      font: 'normal normal normal 13px/30px Open Sans !important',
      letterSpacing: '0px',
      color: '#33333 !important',
      lineHeight: '18px',
      '&. MuiInputBase-root': {
        font: 'normal normal normal 13px/30px Open Sans !important',
        letterSpacing: '0px',
        webkitTextFillColor: '#333333 !important',
        lineHeight: '18px',
      },
    },
    input: {
      color: '#333333 !important',
    },
    disabled: {
      '&.Mui-disabled': {
        '-webkit-text-fill-color': '#333333 !important',
        border: 'none !important',
      },
    },
  })
);

/* eslint-disable-next-line */
export interface CcfCustomerChannelsProps {}

/**
 * CcfCustomerChannels - used to display channels in contact card
 * @param props -? - CcfCustomerChannelsProps
 * @example - <CcfCustomerChannels />
 */
export function CcfCustomerChannels(props: CcfCustomerChannelsProps) {
  const [expanded, setExpanded] = useState('contactchannel');
  const profileData = useSelector(activeContactSelector);
  const dispatch = useDispatch();
  const appDirection: Direction = useSelector(getApplicationDirection);
  const ltrRtlActive = appDirection === 'rtl' ? 'rtlActive' : 'ltrActive';
  const [isEditable, setIsEditable] = useState(false);
  const txtField = useRef<HTMLDivElement>();
  const [translate] = useTranslator();
  const theme = useTheme();
  const stylesAccordion = customerCardStyles(theme);

  const classes = useStyles();
  useEffect(() => {
    txtField?.current?.focus();
  }, [isEditable]);

  useEffect(() => {
    console.log(profileData);
    setChannelsData(channelsDataCopy);
  }, [profileData]);

  /**
   * handleChange Event - used to expand and collapse of channels accordion
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChange = (panel: string) => {
    setExpanded(expanded === 'contactchannel' ? '' : panel);
  };

  /**
   * Function to be called on change of textfield
   * @param  e  - any
   * @param channelDataId - any
   * @param type -any
   * @example -updateFieldValue(e,1,'Email')
   */
  const updateFieldValue = (e: any, channelDataId: any, type: any) => {
    const validator =
      type === 'Email'
        ? /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        : /(^|[^@\w])@(\w{1,15})\b/;
    const validControl = validator.test(e.target.value);
    setChannelsData(
      channelsData?.map((channel) => {
        if (channel.channelsDataId === channelDataId) {
          return { ...channel, value: e.target.value, isValid: validControl };
        }
        return channel;
      })
    );
    setChannelsData((state) => {
      return state;
    });
  };

  /**
   * Function to be called on clickof edit icon
   * @param channelDataId - any
   * @example -handleEditField(1)
   */
  const handleEditField = (channelDataId: any) => {
    setChannelsData(
      channelsData?.map((channel) => {
        if (channel.channelsDataId === channelDataId) {
          return { ...channel, isEdit: true };
        }
        return channel;
      })
    );
    setIsEditable(true);
    setChannelsData((state) => {
      return state;
    });
    setIsEditable((state) => {
      return state;
    });
  };

  /**
   * Function to be called on click of Right icn
   * @param channelDataId - any
   * @example -completeEditing(e,1,'Email')
   */
  const completeEditing = (
    channelDataId: any,
    isChannelFieldValid: boolean
  ) => {
    if (isChannelFieldValid) {
      setChannelsData(
        channelsData?.map((channel) => {
          if (channel.channelsDataId === channelDataId && channel.isEdit) {
            return { ...channel, isEdit: false };
          }
          return channel;
        })
      );
      setChannelsData((state) => {
        return state;
      });
      setIsEditable(false);
      setIsEditable((state) => {
        return state;
      });
      dispatch(
        updateCustomerChnnelInformation({
          id: profileData?.id,
          field: channelsData[channelDataId].field,
          value: channelsData[channelDataId]?.value || '',
        })
      );
    } else {
      setChannelsData(
        channelsData?.map((channel) => {
          if (channel.channelsDataId === channelDataId && channel.isEdit) {
            return { ...channel, isEdit: true };
          }
          return channel;
        })
      );
      setChannelsData((state) => {
        return state;
      });
      setIsEditable(true);
      setIsEditable((state) => {
        return state;
      });
    }
  };

  /**
   * Function to reset value on blur of field
   * @param channelDataId - any
   * @param value - any
   * @example resetValueOnBlur(1,abc)
   */
  const resetValueOnBlur = (channelDataId: any, value: any) => {
    dispatch(
      updateCustomerChnnelInformation({
        id: profileData?.id,
        field: channelsData[channelDataId].field,
        value: channelsData[channelDataId]?.value || '',
      })
    );
    setChannelsData(
      channelsData?.map((channel) => {
        if (channel.channelsDataId === channelDataId && channel.isEdit) {
          return { ...channel, isEdit: false };
        }
        return channel;
      })
    );
    setIsEditable(false);

    setChannelsData((state) => {
      return state;
    });

    setChannelsData((state) => {
      return state;
    });
  };

  /* map the left icon by channel */
  const IconsLeftMap = new Map([
    [
      MediaType.VOICE.toString(),
      <CcfPhoneOutboundIcon className={styles.phoneIcon} />,
    ],
    [MediaType.EMAIL.toString(), <CcfEmailIcon className={styles.emailIcon} />],
    [
      DigitalChannelType.WHATSAPP.toString(),
      <CcfWhatsAppIcon className={styles.whatsappIcon} />,
    ],
    [
      DigitalChannelType.TWITTER.toString(),
      <CcfXIcon className={styles.twitterIcon} />,
    ],
  ]);

  /**
   * Function to render all the right icons
   * @param channel - string
   * @param isEdit - boolean
   * @example
   */
  const renderRightIcons = (channel: string) => {
    switch (channel) {
      case ChannelActions.CHAT.toString():
        return (
          <CcfMessageOutlineIcon
            className={styles.actionIcon}
            classes={{
              root: styles.actionIconColor,
            }}
          />
        );
      case ChannelActions.EMAIL.toString():
        return (
          <CcfMailOutlineIcon
            className={styles.actionIcon}
            classes={{
              root: styles.actionIconColor,
            }}
          />
        );
      case ChannelActions.VIDEO.toString():
        return (
          <CcfVideoOutlineIcon
            className={styles.videoActionIcon}
            classes={{
              root: styles.actionIconColor,
            }}
          />
        );
      case ChannelActions.EDIT.toString():
        return (
          <CcfEditBookIcon
            className={styles.actionIcon}
            classes={{
              root: styles.actionIconColor,
            }}
          />
        );
      case ChannelActions.CALL.toString():
        return (
          <CcfPhoneOutlineIcon
            className={styles.actionIcon}
            classes={{
              root: styles.actionIconColor,
            }}
          />
        );
      case ChannelActions.MENTION.toString():
        return (
          <AlternateEmailIcon
            className={styles.mentionIcon}
            classes={{
              root: styles.actionIconColor,
            }}
          />
        );
      default:
        return '';
    }
  };

  const channelId = new Map([
    [MediaType.VOICE.toString(), profileData?.customer?.phoneNo],
    [MediaType.EMAIL.toString(), profileData?.customer?.emailId],
    [DigitalChannelType.TWITTER.toString(), profileData?.customer?.twitterId],
    [DigitalChannelType.WHATSAPP.toString(), profileData?.customer?.phoneNo],
  ]);

  /* channels mock data */
  const channelsDataCopy = [
    {
      channelsDataId: 0,
      name: 'CELL PHONE',
      field: 'phoneNo',
      value: profileData?.customer?.phoneNo,
      type: 'Voice',
      actions: ['Call', 'Chat'],
      isEdit: false,
      isValid: true,
    },
    {
      channelsDataId: 1,
      name: 'EMAIL',
      field: 'emailId',
      value: profileData?.customer?.emailId,
      type: 'Email',
      actions: ['Email'],
      isEdit: false,
      isValid: true,
    },
    {
      channelsDataId: 2,
      name: 'WHATSAPP',
      field: 'phoneNo',
      value: profileData?.customer?.phoneNo,
      type: 'Whatsapp',
      actions: ['Video', 'Call', 'Chat'],
      isEdit: false,
      isValid: true,
    },
    {
      channelsDataId: 3,
      field: 'twitterId',
      name: 'TWITTER',
      value: profileData?.customer?.twitterId,
      type: 'Twitter',
      actions: ['Mention', 'Chat'],
      isEdit: false,
      isValid: true,
    },
  ];

  const [channelsData, setChannelsData] = useState(channelsDataCopy);

  return (
    <section className={ltrRtlActive}>
      <CcfAccordion
        square
        expanded={expanded === 'contactchannel'}
        onChange={() => handleChange('contactchannel')}
        sx={stylesAccordion.accordionContainer}
      >
        <CcfAccordionSummary
          expandIcon={<CcfDoubleArrowIcon sx={stylesAccordion.expandedIcon} />}
          aria-controls="contact-channel-header"
          sx={
            expanded === 'contactchannel'
              ? stylesAccordion.accordionHeaderExpand
              : stylesAccordion.ccfAppSpaceAccordionHeader
          }
          id="agent_appSpace_channels"
        >
          <CcfBox className={styles.contactChannelInfo}>
            <CcfBox component="div" className={styles.titleRow}>
              <CcfTypography className={styles.title}>
                {' '}
                {translate('channels')}
              </CcfTypography>
              <IconButton classes={{ root: styles.addIcon }} disableRipple>
                <CcfPlusIcon
                  classes={{
                    root: styles.addIconColor,
                  }}
                />
              </IconButton>
            </CcfBox>
            {expanded !== 'contactchannel' && (
              <CcfBox
                component="div"
                className={
                  expanded === 'contactchannel'
                    ? styles.titleDescription
                    : styles.collapsedTitleDescription
                }
              >
                <CcfTypography className={styles.titleTag}>
                  4 {translate('channels')}
                </CcfTypography>
                <IconButton className={styles.statusCount}>
                  <CcfPhoneOutboundIcon className={styles.phoneStatusIcon} />
                </IconButton>
                <IconButton className={styles.statusCount}>
                  <CcfEmailIcon className={styles.emailStatusIcon} />
                </IconButton>
                <IconButton className={styles.statusCount}>
                  <CcfWhatsAppIcon className={styles.whatsupStatusIcon} />
                </IconButton>
                <IconButton className={styles.statusCount}>
                  <CcfXIcon className={styles.twitterStatusIcon} />
                </IconButton>
              </CcfBox>
            )}
          </CcfBox>
        </CcfAccordionSummary>
        <CcfAccordionDetails>
          <section className={styles.channelContainer}>
            {channelsData &&
              channelsData?.map((channel, index) => (
                <CcfBox
                  component="div"
                  className={styles.channel}
                  key={`channel-${index}`}
                >
                  <CcfBox
                    display="flex"
                    component="div"
                    className={styles.channelRow}
                  >
                    <CcfBox display="flex" alignItems="center">
                      <IconButton>{IconsLeftMap.get(channel?.type)}</IconButton>
                      <CcfTypography className={styles.channelName}>
                        {channel?.name}
                      </CcfTypography>
                    </CcfBox>
                    <CcfBox
                      component="div"
                      className={styles.channelActionIcons}
                    >
                      {channel &&
                        channel?.actions?.map((action, key) => (
                          <IconButton
                            classes={{
                              root: styles.iconbtn,
                            }}
                            key={`channel-action-${key}`}
                            className={styles.channelOperations}
                            onClick={(e) => {
                              action === 'Edit' &&
                                channel.field !== 'phoneNo' &&
                                handleEditField(channel.channelsDataId);
                            }}
                          >
                            {renderRightIcons(action)}
                          </IconButton>
                        ))}
                    </CcfBox>
                  </CcfBox>
                  <CcfBox component="div" style={{ padding: '0px 34px' }}>
                    <CcfTypography>{channel.value}</CcfTypography>
                  </CcfBox>
                </CcfBox>
              ))}
          </section>
        </CcfAccordionDetails>
      </CcfAccordion>
    </section>
  );
}

export default CcfCustomerChannels;
